(function () {
  "use strict";

  angular
    .module("virtualFairs")
    .controller(
      "VirtualFairPlatformIntegrationController",
      VirtualFairPlatformIntegrationController
    );

  VirtualFairPlatformIntegrationController.$inject = ["$uibModal", "VirtualFairService"];

  function VirtualFairPlatformIntegrationController($uibModal, VirtualFairService) {
    var vm = this;

    vm.listVirtualFairs = listVirtualFairs;
    vm.getItems = getItems;

    vm.handleSelectIntegration = handleSelectIntegration;
    vm.handleExpoChanged = handleExpoChanged;

    vm.syncItem = syncItem;
    vm.syncItems = syncItems;
    vm.syncPreFair = syncPreFair;
    vm.syncPostFair = syncPostFair;

    vm.openErrorDetails = openErrorDetails;

    vm.expos = [];

    vm.items = null;
    vm.totalItems = null;
    vm.totalItemsSynced = null;
    vm.totalItemsPagination = null;

    vm.isLoading = false;
    vm.isSynchronizingAll = false;
    vm.isSynchronizingItem = {};

    // success, partial, error
    vm.syncResultStatus = "";
    // ids of items synced
    vm.syncResultItems = [];
    // sync errors keyed by item id.
    // key 'all' is for general sync errors.
    vm.syncResultErrors = {};

    // options set on handleExpoChanged
    vm.syncTypeOptions = [];
    vm.syncTypeSelected = "";

    /* PAGINATION */
    vm.pageChanged = pageChanged;
    vm.setPage = setPage;
    vm.page = 1;
    vm.itemsPerPage = null;
    vm.currentPage = null;

    function activate() {
      vm.listVirtualFairs();
    }

    function listVirtualFairs() {
      VirtualFairService.platformSyncFairs({
        platform_system: 2
      })
        .then(function (response) {
          vm.expos = response.data;
        })
        .catch(function (error) {
          console.error(error);
        });
    }

    function handleSelectIntegration() {
      resetVars(true, false);
    }

    function handleExpoChanged() {
      resetVars();

      const finishAt = moment.utc(`${vm.expoSelected.end_datetime_utc}`);
      const isEventEnded = finishAt.isBefore(new Date());

      if (isEventEnded) {
        vm.syncTypeOptions = [
          { id: "post-fair", name: "Post-fair sync" }
        ];
      } else if (vm.expoSelected.id && vm.expoSelected.platform_fair_code) {
        vm.syncTypeOptions = [
          { id: "events", name: "Event" },
          { id: "filters", name: "Filters"},
          { id: "exhibitors", name: "Exhibitors" },
          { id: "visitors", name: "Visitors" },
          { id: "matches", name: "Matches"},
          { id: "meetings", name: "Meetings"},
          { id: "seminars", name: "Seminars"},
          { id: "counselors-v2", name: "Counselors"},
        ];
      } else {
        vm.syncTypeOptions = [
          { id: "events", name: "Event" }
        ];
      }
    }

    function resetVars(resetSyncItems, resetSyncType) {
      resetSyncItems = typeof resetSyncItems !== 'undefined' ? resetSyncItems : true;
      resetSyncType = typeof resetSyncType !== 'undefined' ? resetSyncType : true;

      vm.isLoading = false;
      vm.isSynchronizingAll = false;
      vm.syncResultStatus = "";
      vm.syncResultItems = [];
      vm.syncResultErrors = {};

      if (resetSyncItems) {
        vm.items = null;
        vm.totalItems = null;
        vm.totalItemsSynced = null;
        vm.totalItemsPagination = null;
      }

      if (resetSyncType) {
        vm.syncTypeSelected = "";
      }
    }

    function setPage(page) {
      vm.currentPage = page;
    }

    function pageChanged() {
      vm.page = vm.currentPage;
      vm.getItems();
    }

    function getItems() {
      vm.isLoading = true;

      VirtualFairService.platformSyncInit(
        vm.expoSelected.id,
        vm.syncTypeSelected.id,
        { page: vm.page }
      )
        .then(function (response) {
          if (response.data?.data) {
            vm.items = response.data.data.map((d) => {
              let id = d.id;
              let name = "";
              let sync_key = d.id.toString();
              let synchronized_at = d.synchronized_at;

              switch (vm.syncTypeSelected.id) {
                case 'exhibitors':
                  name = d.exhibitor?.fascia_name || d.exhibitor?.name;
                  sync_key = d.user_id.toString();
                  break;
                case 'post-fair':
                  name = d.exhibitor?.fascia_name || d.exhibitor?.name;
                  sync_key = d.user_id.toString();
                  synchronized_at = d.post_fair_data_imported_at;
                  break;
                case 'visitors':
                  if (typeof d.student_profile !== 'undefined') {
                    name = d.student_profile.fullname;
                  } else {
                    name = d.networking_visitor.name;
                  }
                  sync_key = d.user_id.toString();
                  break;
                case 'seminars':
                  name = d.title;
                  break;
                case 'matches':
                  id = d.user_id;
                  name = d.student_profile.fullname;
                  sync_key = d.user_id.toString();
                  break;
                case 'meetings':
                  name = d.huddle?.expo_user?.exhibitor?.fascia_name || d.huddle?.expo_user?.exhibitor?.name;
                  break;
                case 'counselors-v2':
                  name = d.name;
                  break;
                default:
                  break;
              }

              return { ...d, id, name, sync_key, synchronized_at }
            });

            if (vm.totalItems === null) {
              vm.totalItems = response.data.total;

              if (vm.syncTypeSelected.id === 'matches') {
                vm.totalItems = response.data.total_matches;
              }
            }

            if (vm.totalItemsSynced === null) {
              vm.totalItemsSynced = response.data.total_synced;
            }

            if (vm.totalItemsPagination === null) {
              vm.totalItemsPagination = response.data.total;
            }

            if (vm.itemsPerPage === null) {
              vm.itemsPerPage = response.data.per_page;
            }

            vm.setPage(response.data.current_page);
          } else {
            vm.items = [];
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function() {
          vm.isLoading = false;
        });
    }

    function syncItem(item) {
      vm.syncItems(true, item.sync_key);
    }

    async function syncItems(include_synced, item_id) {
      include_synced = typeof include_synced !== 'undefined' ? include_synced : false;
      item_id = typeof item_id !== 'undefined' ? item_id : null;

      resetVars(false, false);

      if (vm.syncTypeSelected.id === 'post-fair') {
        await vm.syncPostFair()
      } else {
        await vm.syncPreFair(include_synced, item_id)
      }
    }

    async function syncPreFair(include_synced, item_id) {
      if (item_id) {
        vm.isSynchronizingItem[item_id] = true;
      } else {
        vm.isSynchronizingAll = true;
      }

      VirtualFairService.platformSyncNew(
        vm.expoSelected.id,
        vm.syncTypeSelected.id,
        include_synced,
        item_id
      )
        .then((response) => {
          console.log('then', response);

          // all or some items synced successfully
          if (response.data?.synchronized.length) {
            vm.syncResultItems = response.data.synchronized;

            console.log('then', 'errors', response.data?.errors);

            if (response.data?.errors && Object.keys(response.data?.errors).length) {
              vm.syncResultStatus = "partial";
            } else {
              vm.syncResultStatus = "success";
            }

            vm.getItems();
          } else if (Object.keys(response.data?.errors).length) {
            vm.syncResultStatus = "error";
          } else {
            vm.syncResultStatus = "";
          }

          vm.syncResultErrors = response.data?.errors;
        })
        .catch((err) => {
          vm.syncResultStatus = "error";
          vm.syncResultErrors = { 'all': err.data?.message };

          console.log('catch', err, vm.syncResultErrors);
        })
        .finally(() => {
          if (item_id) {
            vm.isSynchronizingItem[item_id] = false;
          } else {
            vm.isSynchronizingAll = false;
          }

          console.log('finally');
        });
    }

    async function syncPostFair() {
      vm.isSynchronizingAll = true;

      VirtualFairService.platformSyncNew(
        vm.expoSelected.id,
        vm.syncTypeSelected.id,
        false,
      )
        .then((response) => {
          console.log('then', response);

          // all or some items synced successfully
          if (response.data?.data?.status === "in_progress") {
            vm.syncResultStatus = "partial";

            vm.syncResultErrors = {
              'all': "Post-fair data is being generated. Try again in a couple minutes."
            };
          } else {
            if (response.data?.synchronized.length) {
              vm.syncResultItems = response.data.synchronized;

              console.log('then', 'errors', response.data?.errors);

              if (response.data?.errors && Object.keys(response.data?.errors).length) {
                vm.syncResultStatus = "partial";
              } else {
                vm.syncResultStatus = "success";
              }

              vm.getItems();
            } else if (Object.keys(response.data?.errors).length) {
              vm.syncResultStatus = "error";
            } else {
              vm.syncResultStatus = "";
            }

            vm.syncResultErrors = response.data?.errors;
          }
        })
        .catch((err) => {
          vm.syncResultStatus = "error";
          vm.syncResultErrors = { 'all': err.data?.message };

          console.log('catch', err, vm.syncResultErrors);
        })
        .finally(() => {
          vm.isSynchronizingAll = false;
          console.log('finally');
        });
    }

    function openErrorDetails(item) {
      $uibModal.open({
        templateUrl:
          "templates/virtualfairs/report/platform-integration/details/template.modal.html",
        controller: "VirtualFairPlatformIntegrationDetailController",
        controllerAs: "vm",
        resolve: {
          item: () => item,
          error: () => vm.syncResultErrors[item.sync_key]
        },
      });
    }

    activate();
  }
})();
